import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { saveTimezone } from 'redux/modules/organization';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { PageHeader } from 'components';
var OrgBillingHistory = (_dec = connect(function (state) {
  return {
    config: state.config,
    organization: state.organization.current,
    savingTimezone: state.organization.savingTimezone,
    timezones: state.config.timezones,
    selectedTimezone: state.organization.current.OrganizationTimezone && state.organization.current.OrganizationTimezone.details ? state.organization.current.OrganizationTimezone.details : {
      name: 'US/Eastern'
    }
  };
}, {
  saveTimezone: saveTimezone
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(OrgBillingHistory, _Component);

  var _super = _createSuper(OrgBillingHistory);

  function OrgBillingHistory() {
    _classCallCheck(this, OrgBillingHistory);

    return _super.apply(this, arguments);
  }

  _createClass(OrgBillingHistory, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 36,
          paddingTop: 0
        },
        id: "OrgTimezone"
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Timezone Setting"
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Timezone Setting"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("p", null, "We use this timezone for scheduling content and ads."), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(SelectField, {
        disabled: this.props.savingTimezone,
        floatingLabelText: "Timezone",
        value: this.props.selectedTimezone.name,
        onChange: function onChange(e, key, value) {
          _this.props.saveTimezone(_this.props.organization.id, value);
        },
        autoWidth: true
      }, this.props.timezones.map(function (tz) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: tz.name,
          key: tz.name,
          primaryText: tz.name
        });
      }))))))));
    }
  }]);

  return OrgBillingHistory;
}(Component)) || _class);
export { OrgBillingHistory as default };